import { useQuery as useRQQuery } from '@tanstack/react-query';

import { useApiClientCtx } from '@/react-query/context/ApiClientContextController';
import { StandardizedApiError } from '@/services/client/types';
import { UseQueryOptions } from './useQuery.types';

export const useQuery = <TQueryFnData = unknown, TError = StandardizedApiError>(
  params: UseQueryOptions<TQueryFnData, TError>,
) => {
  const { client } = useApiClientCtx();
  const { queryFn, ...options } = params;
  const result = useRQQuery({
    queryFn: (args) => queryFn(client)(args),
    ...options,
  });

  return { ...result, isLoadingAndEnabled: result.isPending && result.fetchStatus !== 'idle' };
};
